import React from 'react';
import { Card, CardContent } from './ui/card';
import { Home, DollarSign, Shield, TrendingUp, Users, PiggyBank } from 'lucide-react';
import { benefits } from '../mock';

const iconMap = {
  Home,
  DollarSign,
  Shield,
  TrendingUp,
  Users,
  PiggyBank
};

export const Benefits = () => {
  return (
    <section id="benefits" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            The Financial Planning Mechanics of a Reverse Mortgage
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Access your home equity through a strategic lens—coordinating with your broader retirement income plan, tax situation, and long-term wealth preservation goals.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <Card 
                key={benefit.id} 
                className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-blue-200"
              >
                <CardContent className="p-8">
                  <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors duration-300">
                    <IconComponent className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
